<template>
    <div :class="containerClass">
        <!-- <AppNews /> -->
        <AppTopBar @menubutton-click="onMenuButtonClick" />
        <!-- <div :class="['layout-mask', { 'layout-mask-active': sidebarActive }]" @click="onMaskClick"></div> -->
        <div class="layout-content-index !p-0">
            <!-- <app-menu :active="sidebarActive" /> -->
            <div class="layout-content-slot !p-0">
                <slot></slot>
            </div>
        </div>
        <!-- <AppFooter /> -->
        <Toast />
        <Toast position="top-left" group="tl" />
        <Toast position="bottom-left" group="bl" />
        <Toast position="bottom-right" group="br" />
    </div>
    <ClientOnly>
        <ConfirmDialog group="headless" style="width: fit-content">
            <template #container="{ message, acceptCallback, rejectCallback }">
                <div class="flex flex-col items-center p-8 bg-surface-0 dark:bg-surface-900 rounded">
                    <div
                        class="rounded-full bg-primary text-primary-contrast inline-flex justify-center items-center h-24 w-24 -mt-20">
                        <i :class="`pi ${message.icon} text-5xl text-white`"></i>
                    </div>
                    <span class="font-bold text-2xl block mb-2 mt-6">{{ message.header }}</span>
                    <p class="mb-0 text-lg">{{ message.message }}</p>
                    <div class="flex items-center gap-2 mt-6">
                        <Button label="ĐỒNG Ý" @click="acceptCallback"></Button>
                        <Button label="KHÔNG" outlined @click="rejectCallback"></Button>
                    </div>
                </div>
            </template>
        </ConfirmDialog>
    </ClientOnly>
</template>

<script>
import { blockBodyScroll, unblockBodyScroll } from '@primeuix/utils/dom';

export default {
    data() {
        return {
            sidebarActive: false
        };
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                if (!process.client || typeof window === 'undefined') {
                    return;
                }

                this.sidebarActive = false;
                unblockBodyScroll('blocked-scroll');
                this.$toast.removeAllGroups();
            }
        }
    },
    methods: {
        onMenuButtonClick() {
            if (this.sidebarActive) {
                this.sidebarActive = false;
                unblockBodyScroll('blocked-scroll');
            } else {
                this.sidebarActive = true;
                blockBodyScroll('blocked-scroll');
            }
        },
        onMaskClick() {
            this.sidebarActive = false;
            unblockBodyScroll('blocked-scroll');
        }
    },
    computed: {
        containerClass() {
            return [
                'layout-wrapper',
                {
                    'layout-news-active': this.$appState.newsActive
                }
            ];
        }
    }
};
</script>
